import { Component, OnInit, Input } from '@angular/core';
import { SecretsAddEditComponent } from './parts/add-edit/add-edit.component';

@Component({
  selector: 'app-secrets',
  templateUrl: './secrets.component.html',
  styleUrls: ['./secrets.component.scss']
})
export class SecretsComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  public key: string;
  public extraData: Object;

  constructor() { }

  ngOnInit(): void {

    this.key = 'secret';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: SecretsAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'secret',
        title: 'Secrets',
        type: 'children',
        childType: 'secret',
        plural: 'secrets',
        singular: 'Secret',
        min: 0,
        max: 0,
      },
    }

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
